export default class Atc {
	code: string;

	activeSubstance: string;

	constructor(code: string, activeSubstance: string) {
		this.code = code;
		this.activeSubstance = activeSubstance;
	}
}
